import script from "./VerCarrito.vue?vue&type=script&setup=true&lang=js"
export * from "./VerCarrito.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=b40c44c6&scoped=true&lang=css"
import "@/assets/plantilla/tabla-responsiva-carrito.css?vue&type=style&index=1&id=b40c44c6&scoped=true&lang=css"
import "./VerCarrito.vue?vue&type=style&index=2&id=b40c44c6&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b40c44c6"]])

export default __exports__